"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("@wix/social-groups-api/dist/src/types");
var Tab;
(function (Tab) {
    Tab["DISCUSSION"] = "discussion";
    Tab["MEDIA"] = "media";
    Tab["MEMBERS"] = "members";
    Tab["ABOUT"] = "about";
})(Tab = exports.Tab || (exports.Tab = {}));
exports.TabKeyMap = (_a = {},
    _a[Tab.DISCUSSION] = types_1.ApiTypes.v1.GroupAppKey.FEED_APP,
    _a[Tab.ABOUT] = types_1.ApiTypes.v1.GroupAppKey.ABOUT_APP,
    _a[Tab.MEMBERS] = types_1.ApiTypes.v1.GroupAppKey.MEMBERS_APP,
    _a[Tab.MEDIA] = types_1.ApiTypes.v1.GroupAppKey.GALLERY_APP,
    _a);
//# sourceMappingURL=tab.js.map